// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__3VQOI","fadeIn":"Notification_fadeIn__3f_Nn"};